import * as React from "react";
import {translate} from "react-i18next";
import {ITranslatedComponent} from "../../../redux/reducers/generalReducer";
import Button from "../../../components/Button";
import Dialog from "../../../components/Dialogs/Dialog";

interface IModeltypeBasicViewProps extends ITranslatedComponent {
    title: React.ReactNode;
    onSave?(): void;
    onCancel?(): void;
    onExit?(): void;
}

class SaveConfirmDialog extends React.Component<IModeltypeBasicViewProps> {
    render() {
        // show dialog to confirm the Reset
        const {t, title, onSave, onCancel, onExit} = this.props;
        let actions =
            [
                // set other icon
                <Button key={1} icon={"save"} label={t("SAVE")} onClick={onSave} />,
                <Button key={2} icon={"close"} label={t("EXIT")} onClick={onExit} />,
                <Button key={3} icon={"ban"} label={t("CANCEL")} onClick={onCancel} />,

            ];
        return (
            <Dialog
                title={title}
                open={true}
                actions={actions}
                fullWidth={false}
            >
            {this.props.children}
            </Dialog>
        );
    }
}
export default translate("GLOBAL")(SaveConfirmDialog);



// WEBPACK FOOTER //
// ./src/views/AdminView/WorkflowTab/SaveConfirmDialog.tsx